<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">Document Management Report
      </legend>
    </div>
    <div class="grid-col-2 margin-top-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button
            class="usa-accordion__button define-eclipse"
            aria-expanded="false"
            aria-controls="more-actions">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a (click)="goBack()" routerLink="">Document Management</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="grid-row margin-top-2">
    <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon">
    Right click on the report and select the appropriate options to export.
  </div>
  <div class="grid-row margin-top-2">
    <span class="new-carrier"> TSP's with no documents are listed in blue.</span>
    <span class="doc-expired"> TSP's with expired documents are listed in orange.</span>
  </div>
  <div class="margin-top-2">
    <ag-grid-angular class="ag-theme-alpine"
                     style="height: 600px;"
                     [rowData]="documentManagementList"
                     [gridOptions]="gridOptions"
                     [domLayout]="domLayout"
                     [pagination]="true"
                     [excelStyles]="excelStyles"
                     [paginationPageSize]="paginationPageSize"
                     [columnDefs]="docMgmtRptColumnDefs">
    </ag-grid-angular>
  </div>
</div>

